// Détecte si le point de départ d'un geste se trouve dans une zone scrollable
// horizontalement (barres de catégories, tableaux présence/inventaire/utilisateurs…).
// Dans ce cas, le swipe horizontal appartient à la zone et ne doit pas déclencher
// le retour à la page précédente.
export const isHorizontalScrollZone = (target) => {
  let el = target instanceof Element ? target : null;
  while (el && el !== document.body) {
    if (el.scrollWidth - el.clientWidth > 4) {
      const ox = window.getComputedStyle(el).overflowX;
      if (ox === "auto" || ox === "scroll") return true;
    }
    el = el.parentElement;
  }
  return false;
};
